import { StyleSheet } from 'react-native';
import { brand } from '../../../styles/rn';
var Styles = StyleSheet.create({
  inputErrMsgWithPadding: {
    color: brand
  },
  container: {
    width: '100%'
  },
  'popup-content': {
    padding: 0
  },
  order: {
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderBottomWidth: 0.5,
    width: '100%',
    height: 96,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12
  },
  'order-img': {
    width: 72,
    height: 72,
    borderRadius: 2
  },
  'order-arrow': {
    width: 16,
    height: 16
  },
  'order-center': {
    paddingHorizontal: 8,
    flex: 1,
    height: 72
  },
  'order-name': {
    width: '100%',
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    marginTop: 4
  },
  'order-center-center': {
    width: '100%',
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4
  },
  'order-count': {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'order-price': {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'order-status': {
    width: '100%',
    marginTop: 8
  },
  'order-status-text': {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  email: {
    padding: 12,
    paddingTop: 16,
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderBottomWidth: 0.5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  'email-text-title': {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.65)'
  },
  'email-text-value': {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.65)',
    marginTop: 12
  },
  'button-text': {
    color: 'white',
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 20
  },
  'select-order': {
    padding: 12,
    paddingTop: 16
  },
  'select-order-label-wrapper': {
    marginBottom: 8
  },
  'select-order-label': {
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'select-order-button-text': {
    color: 'rgba(238, 77, 45, 1)',
    textAlign: 'center'
  }
});
export default Styles;